export default __webpack_public_path__ + "static/gold-rush-bg-414ce183afda041923a4e7659718c37a.jpg";